import React from 'react';
import IntroPisoSpc from '../components/sections/Piso-Spc/IntroPisoSpc';
import TituloPisoSpc from '../components/sections/Piso-Spc/TituloPisoSpc';
import CaracteristicasGeneralesSpc from '../components/sections/Piso-Spc/CaracteristicasGeneralesSpc';
import CaracteristicaUnoSpc from '../components/sections/Piso-Spc/CaracteristicaUnoSpc';
import CatalogoProductosSpc from '../components/sections/Piso-Spc/CatalogoProductosSpc';
import FormularioContactoSpc from '../components/sections/Piso-Spc/FormularioContactoSpc';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const PisosSpcPages = () => {
  return (
    <div>
      <Header />
       {/* Sección introductoria del piso vinílico LVT */}
       <TituloPisoSpc />

       <IntroPisoSpc />

       <CaracteristicasGeneralesSpc />  

       <CaracteristicaUnoSpc /> 

       <CatalogoProductosSpc />  

       <FormularioContactoSpc/>

      <Footer />
    </div>
  );
};

export default PisosSpcPages;
